import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["field", "status"];
  static classes = ["invalid"];

  connect() {
    const gsm7Chars =
      "@£$¥èéùìòÇ\nØø\rÅåΔ_ΦΓΛΩΠΨΣΘΞÆæßÉ !\"#¤%&'()*+,-./0123456789:;<=>?¡ABCDEFGHIJKLMNOPQRSTUVWXYZÄÖÑÜ§¿abcdefghijklmnopqrstuvwxyzäöñüà{}^[\\]~|€";
    this.gsm7Set = new Set(gsm7Chars);
    this.maxCharsGsm7 = 160; // Maximum characters for GSM-7 encoding (single SMS)
    this.maxCharsUcs2 = 70; // Maximum characters for UCS-2 encoding (single SMS with non-GSM-7 chars)
  }

  check() {
    const text = this.fieldTarget.value;
    const segmenter = new Intl.Segmenter();
    const graphemes = Array.from(segmenter.segment(text), (s) => s.segment);
    const invalidChars = graphemes.filter((g) => !Array.from(g).every((c) => this.gsm7Set.has(c)));
    const isValid = invalidChars.length === 0;
    const plural = invalidChars.length === 1 ? "" : "s";

    if (!isValid) {
      this.statusTarget.textContent = `Contains unicode character${plural}: ${invalidChars.join(
        ", "
      )} limiting a single part to ${this.maxCharsUcs2} characters.`;
    } else {
      this.statusTarget.textContent = "";
    }

    if (this.hasInvalidClass && isValid) {
      this.fieldTarget.classList.remove(this.invalidClass);
    }

    if (this.hasInvalidClass && !isValid) {
      this.fieldTarget.classList.add(this.invalidClass);
    }

    // Dispatch custom event for other controllers to consume
    this.dispatch("validation", {
      detail: {
        valid: isValid,
        maxChars: isValid ? this.maxCharsGsm7 : this.maxCharsUcs2,
      },
    });
  }
}
